<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" class="mt15"  :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="classname"  @change="handleTableChange">
            <template slot="operation" slot-scope="text, record">
                <router-link v-if="record.accessmode != 'local'" class="tableLink"  :to="{path:'edit_processorClass',query: {domain: record.domain,classname: record.classname,}}">编辑</router-link>

                <router-link class="tableLink" :to="{path:'detail_processorClass',query: {domain: record.domain,classname: record.classname,}}">详情</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
            <template slot="domainNames" slot-scope="text">
                <span >{{ domainName[text] }}</span>
            </template>
        </a-table>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const domainName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础',
}
const accessmodeName = {
    'local':'本地获取',
    'remote':'远程获取'
}

const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    
    {
        title: "所属领域",
        dataIndex: "domain",
        align: "center",
        scopedSlots: { customRender: 'domainNames' },
        width:80
    },

    {
        title: "类名",
        dataIndex: "classname",
        align: "center",
        width:400,
        ellipsis: true,
    },
    {
        title: "获取模式",
        dataIndex: "accessmode",
        align: "center",
        width:100,
        customRender: text => {
            return accessmodeName[text]
        },
        ellipsis: true,
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        align: "center",
        width:200,
        ellipsis: true,
    },
    {
        title: "更新时间",
        dataIndex: "updatetime",
        align: "center",
        width:200,
        ellipsis: true,
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            ordercoloum:'total',
            orderstr:'desc',
            searchP:{},
            platforms:[],
            domainName
        };
    },
    methods: {
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "servicekey/processorDelClass",
                params: {classname: item.classname,domain:item.domain}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
            
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "servicekey/processorQueryClassListPage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },
    },

    components:{
        
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

